import map from 'lodash/map';
import each from 'lodash/each';

export default ({ selected, page, sorting }) => {
  const query = {};

  if (selected && typeof selected === 'object') {
    each(selected, (value, key) => {
      if (Array.isArray(value)) {
        const vals = map(value, v => encodeURIComponent(v));
        query[key] = vals.join(',');
      } else if (value !== undefined && value !== null) {
        query[key] = value;
      }
    });
  }

  if (page && page.current > 1) {
    query.page = page.current;
  }

  if (sorting) {
    const { by, direction } = sorting;
    if (by && by !== 'position') {
      query.sortby = by;
    }
    if (direction === 'desc') {
      query.sortdir = direction;
    }
  }

  return query;
};